module.exports = __webpack_public_path__ + "static/media/sparkles2.43f58c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/sparkles2.png
// module id = 10
// module chunks = 0